export default "__VITE_ASSET__ac406746__"